import script from "./OutgoingFaxEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./OutgoingFaxEditor.vue?vue&type=script&setup=true&lang=js"

import "./OutgoingFaxEditor.vue?vue&type=style&index=0&id=6e21ea44&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e21ea44"]])

export default __exports__